import { ButtonProps } from '@/shared/ui';

import { StyledButton } from './styles/listItemButtonStyles';

interface IListItemButtonProps extends ButtonProps {
  children?: React.ReactNode;
  component?: React.ElementType;
  href?: string;
  rel?: string;
  target?: string;
}

export const ListItemButton = ({
  children,
  ...otherProps
}: IListItemButtonProps) => {
  return (
    <StyledButton {...otherProps} variant="text" size="small">
      {children}
    </StyledButton>
  );
};
